import { SVGProps } from "react"

export function IconThumbsDown(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" {...props}>
      <defs>
        <clipPath id="a">
          <path fill="none" d="M0 0h500v500H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)">
        <circle cx="245.404" cy="242.666" r="177.173" fill="#c5d3d6" />
        <path
          fill="#00515f"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M296.336 43.044c17.243-11.71 42.018-10.999 69.511 4.874 51.888 29.958 93.811 102.579 93.642 162.203-.073 25.555-7.866 44.575-20.834 55.608l-47.077 29.031L259.933 65.508z"
        />
        <path
          fill="#00515f"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M330.143 69.887c51.888 29.958 93.811 102.579 93.642 162.203s-42.366 83.67-94.254 53.713-93.818-102.575-93.649-162.199 42.373-83.674 94.261-53.717"
        />
        <path
          fill="#eef4f6"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M328.494 101.668c37.259 21.511 67.362 73.658 67.24 116.471s-30.421 60.08-67.68 38.569-67.367-73.655-67.245-116.468 30.426-60.083 67.685-38.572"
        />
        <path
          fill="#fff"
          d="M293.348 103.994c-9.898 7.655-17.025 13.33-24.851 19.108 0 0-36.445-8.696-62.829 25.227-4.031-13.245-34.84-9.214-47.222-4.607s-39.448 5.471-38.872 39.735c.155 9.253 2.822 15.886 6.83 20.731-1.302-.003-19.349.459-15.319 28.219.878 6.046 3.272 10.895 6.602 14.845l-2.144-2.464c-5.471 3.743-5.084 20.88-4.031 31.097.578 5.606 4.352 10.53 9.749 14.794-3.797 27.263 13.477 31.11 51.006 55.175 26.745 17.149 44.549 14.066 57.239 7.921-.924 5.041 2.364 14.826 2.364 14.826s-10.285 41.447 14.973 61.331c27.066 21.308 41.463-6.526 34.361-28.026-6.342-19.197 4.223-53.173 12.285-66.129s33.257-39.448 30.017-62.979c15.046-10.591 27.341-16.988 43.091-24.549 48.171-67.298-47.777-154.549-73.249-144.255"
        />
        <path
          fill="none"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M283.892 311.302c-11.025 6.697-34.741 30.549-41.079 34.553-12.877 8.135-32.825 24.187-70.545 0s-54.996-27.93-50.965-55.572m32.249-131.589s31.961 15.549 52.117-10.366c26.384-33.923 62.829-25.227 62.829-25.227 7.825-5.778 14.952-11.453 24.851-19.108 25.472-10.294 121.42 76.957 73.249 144.255-15.751 7.561-28.046 13.957-43.092 24.548"
        />
        <path
          fill="none"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M185.916 315.678s-71.955-16.038-74.403-39.793c-1.053-10.218-1.44-27.354 4.031-31.097"
        />
        <path
          fill="none"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M177.336 271.912c-12.381-4.607-62.07-10.712-66.25-39.505s15.4-28.218 15.4-28.218"
        />
        <path
          fill="none"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M177.336 224.402c-10.942-3.455-57.185-6.68-57.761-40.945s26.49-35.128 38.872-39.735c12.381-4.607 43.191-8.638 47.222 4.607m117.837 124.468c3.768 21.963-21.954 50.022-30.017 62.979s-18.627 46.933-12.285 66.13c7.102 21.499-7.294 49.333-34.361 28.026-25.258-19.884-14.973-61.331-14.973-61.331s-3.288-9.786-2.364-14.827"
        />
        <path
          fill="none"
          stroke="#1d1d1b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.778"
          d="M173.419 153.511s4.891 5.102 3.741 9.749m41.565 147.3 6.488-3.992m-15.389-38.06 6.349-2.715M206.386 223l6.613-1.526"
        />
      </g>
    </svg>
  )
}
